var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-icon",on:{"click":function($event){_vm.goBack()}}},[_c('span',{staticClass:"iconfont icon-fanhui"})]),_c('div',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }